import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textInput" }
const _hoisted_2 = {
  class: "label",
  for: "tbox1"
}
const _hoisted_3 = { class: "counter" }
const _hoisted_4 = ["maxlength", "value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString($props.Title), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString($props.remaningLengthStyle) + "/" + _toDisplayString($props.maxStyle), 1),
      _createElementVNode("input", {
        class: _normalizeClass(["input", { disable: $props.disableStyle, errorStyle: $props.errorMsgStyle }]),
        type: "text",
        id: "tbox1",
        name: "tbox1",
        maxlength: $props.maxStyle,
        value: $props.inputStyleName,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $options.handleEmit($event.target)))),
        required: "",
        disabled: $props.disableStyle
      }, null, 42, _hoisted_4),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
    ])
  ]))
}